export const multiSelectRolesOptions = (arr: any[]) => {
  return arr.map(el => ({ label: el.name, value: el.value }));
};

export const multiSelectOptionsFromArrayOfObjects = (arr: any[]) => {
  return arr.map(el => ({ label: el.name, value: el.id }));
};
